import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    FadeInOut,
    FadeInOutContainer,
} from 'wanderu-animations';
import { localize } from 'wanderu-i18n';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import ClearIcon from './ClearIcon/ClearIcon';
import InputCaret from './InputCaret/InputCaret';
import PasswordIcon from './PasswordIcon/PasswordIcon';
import ValidityIcon from './ValidityIcon/ValidityIcon';

import styles from './InputIndicators.scss';

export function InputIndicators(props) {
    const {
        className,
        onTogglePasswordVisibility,
        onInputCaretClick,
        onClearClick,
        passwordAsPlaintext,
        showClearIcon,
        showValidityIcon,
        showPasswordIcon,
        showInputCaret,
        isValid,
        isActive,
        t,
    } = props;

    function _preventBlurEvent(e) {
        e.preventDefault();
    }

    function _renderValidityIcon() {
        return (
            <ValidityIcon
                className={styles.indicator}
                data-id="validity"
                isValid={isValid}
                onClick={onClearClick}
            />
        );
    }

    function _renderClearIcon() {
        return (
            <ClearIcon
                className={styles.clickableIndicator}
                data-id="clear"
                onClick={onClearClick}
                onMouseDown={_preventBlurEvent}
                title={t('clear-button')}
            />

        );
    }

    function _renderPasswordIcon() {
        return (
            <PasswordIcon
                className={styles.clickableIndicator}
                data-id="password"
                onClick={onTogglePasswordVisibility}
                onMouseDown={_preventBlurEvent}
                passwordAsPlaintext={passwordAsPlaintext}
            />
        );
    }

    function _renderInputCaret() {
        return (
            <InputCaret
                className={styles.clickableIndicator}
                isActive={isActive}
                onClick={onInputCaretClick}
            />
        );
    }

    return (
        <FadeInOutContainer
            childClassName={styles.indicatorContainer}
            className={classNames(className, styles.container)}
            duration={300}
        >
            {showValidityIcon && (
                <FadeInOut>
                    {_renderValidityIcon()}
                </FadeInOut>
            )}
            {showClearIcon && (
                <FadeInOut>
                    {_renderClearIcon()}
                </FadeInOut>
            )}
            {showPasswordIcon && (
                <FadeInOut>
                    {_renderPasswordIcon()}
                </FadeInOut>
            )}
            {showInputCaret && (
                <FadeInOut>
                    {_renderInputCaret()}
                </FadeInOut>
            )}
        </FadeInOutContainer>
    );
}

InputIndicators.propTypes = {
    onTogglePasswordVisibility: PropTypes.func,
    onInputCaretClick: PropTypes.func,
    onClearClick: PropTypes.func,
    passwordAsPlaintext: PropTypes.bool,
    showClearIcon: PropTypes.bool,
    showValidityIcon: PropTypes.bool,
    showPasswordIcon: PropTypes.bool,
    showInputCaret: PropTypes.bool,
    isValid: PropTypes.bool,
    isActive: PropTypes.bool,
    t: PropTypes.func.isRequired,
};

InputIndicators.defaultProps = {
    onTogglePasswordVisibility() {},
    onInputCaretClick() {},
    onClearClick() {},
    passwordAsPlaintext: false,
    showClearIcon: false,
    showValidityIcon: false,
    showPasswordIcon: false,
    showInputCaret: false,
    isValid: true,
    isActive: false,
};

export default localize(InputIndicators, ['t'], baseAppConfig.namespace);
